<!--
File Name          : unsupported-browser.component.html
Author             : Jared Laine Dyreson
Version            : 0.1.0
Date               : 2026-03-18
Description        : Short Description (manual edit required)

Copyright (C) Innovative Design Labs, Inc. - All Rights Reserved
Unauthorized copying of this file, via any medium is strictly prohibited
This file is subject to the terms and conditions defined in
file 'IDL_PROJECTTECH_LICENSE.txt', which is part of this source code package.
-->

<div class="component-container">
    <div class="lessons-card">
        <img src="/assets/branding/secondary_logo.svg" alt="Datasnap">

        <h2>Sorry!</h2>
        <div>Datasnap is only supported on Chrome or Edge. Please use one of these supported browsers!</div>
    </div>
    
</div>